/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParcImmobilierMinimalDto
 */
export interface ParcImmobilierMinimalDto {
    /**
     * 
     * @type {string}
     * @memberof ParcImmobilierMinimalDto
     */
    id: string;
    /**
     * Numéro de parc unique
     * @type {string}
     * @memberof ParcImmobilierMinimalDto
     */
    reference: string;
    /**
     * Libellé du parc
     * @type {string}
     * @memberof ParcImmobilierMinimalDto
     */
    name: string;
    /**
     * Propriétaire (bailleur) du parc
     * @type {string}
     * @memberof ParcImmobilierMinimalDto
     */
    ownerId: string;
    /**
     * Nombre de biens rattachés au parc
     * @type {number}
     * @memberof ParcImmobilierMinimalDto
     */
    realEstatesCount: number;
    /**
     * Surface cumulée des biens du parc
     * @type {number}
     * @memberof ParcImmobilierMinimalDto
     */
    totalArea?: number;
    /**
     * Loyer mensuel cumulé des biens du parc
     * @type {number}
     * @memberof ParcImmobilierMinimalDto
     */
    totalRent?: number;
}

/**
 * Check if a given object implements the ParcImmobilierMinimalDto interface.
 */
export function instanceOfParcImmobilierMinimalDto(value: object): value is ParcImmobilierMinimalDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('reference' in value) || value['reference'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('ownerId' in value) || value['ownerId'] === undefined) return false;
    if (!('realEstatesCount' in value) || value['realEstatesCount'] === undefined) return false;
    return true;
}

export function ParcImmobilierMinimalDtoFromJSON(json: any): ParcImmobilierMinimalDto {
    return ParcImmobilierMinimalDtoFromJSONTyped(json, false);
}

export function ParcImmobilierMinimalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParcImmobilierMinimalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'reference': json['reference'],
        'name': json['name'],
        'ownerId': json['ownerId'],
        'realEstatesCount': json['realEstatesCount'],
        'totalArea': json['totalArea'] == null ? undefined : json['totalArea'],
        'totalRent': json['totalRent'] == null ? undefined : json['totalRent'],
    };
}

export function ParcImmobilierMinimalDtoToJSON(json: any): ParcImmobilierMinimalDto {
    return ParcImmobilierMinimalDtoToJSONTyped(json, false);
}

export function ParcImmobilierMinimalDtoToJSONTyped(value?: ParcImmobilierMinimalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'reference': value['reference'],
        'name': value['name'],
        'ownerId': value['ownerId'],
        'realEstatesCount': value['realEstatesCount'],
        'totalArea': value['totalArea'],
        'totalRent': value['totalRent'],
    };
}

